export const environment = {
  production: true,
  URL_API_CMS: 'https://cms-integracao.rodobens.com.br/api',
  URL_API: 'https://portalfornecedor-backend.rodobens.com.br/api',
  POLICY_DOCUMENT_CODE: 'politicaprivacidade',
};
